<template>
  <div class="users">
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column column is-full">
            <div class="box">
              <div class="columns" style="margin-top: 16px">              
                <div class="column">
                </div>
                <div class="column is-narrow">
                  <b-field grouped group-multiline>
                    <b-select v-model="selectedRole"
                              :placeholder="$t('users-view.user-role-placeholder')">
                      <option
                          v-for="option in userRoles"
                          :value="option.id"
                          :key="option.id">
                        {{ $t(option.translationKey) }}
                      </option>
                    </b-select>
                    <div class="control is-flex">
                      <b-switch v-model="isOnlyArchived">{{ $t('users-view.show-archived-users-filter') }}</b-switch>
                    </div>
                  </b-field>
                </div>
              </div>
              <b-table class="users-table" :data="usersData" :striped="true" :hoverable="false"
                       :mobile-cards="true" :loading="isLoading" :scrollable="true">

                <b-table-column field="name" :label="this.$t('users-view.user-full-name-column')" v-slot="props" searchable sortable>
                  <a :href="userDetailsLink(props.row.user.document_id)">{{ props.row.name }}</a>
                </b-table-column>

                <b-table-column field="user.email" :label="this.$t('users-view.user-email-column')" v-slot="props" searchable>
                  {{ props.row.user.email }}
                </b-table-column>

                <b-table-column field="role" :label="this.$t('users-view.user-role-column')" v-slot="props" sortable>
                  {{
                    $t(userRoleOptions.find(obj => {
                      return obj.id === props.row.role
                    }).translationKey)
                  }}
                </b-table-column>

                <b-table-column :visible="isOnlyArchived" field="is_archived" :label="this.$t('users-view.archived-column')" 
                                v-slot="props" centered>
                  <b-icon v-if="props.row.user.is_archived"
                          icon="check"
                          type="is-primary">
                  </b-icon>
                </b-table-column>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "Users",
  data() {
    return {
      usersData: [],
      isLoading: false,
      isOnlyArchived: false,
      selectedRole: "all"
    }
  },
  watch: {
    isOnlyArchived: function () {
      this.readUsersData();
    },
    selectedRole: function () {
      this.readUsersData();
    }
  },
  methods: {
    readUsersData: function () {
      this.isLoading = true
      this.usersData = []
      const functions = firebase.app().functions("europe-west3");
      const getUsersFunction = functions.httpsCallable(this.getSubmitEndpoint());
      const payload = {
        action: "get_users", fill_meta: true,
        filters: [['is_archived', '==', this.isOnlyArchived]]
      }
      if (this.selectedRole !== 'all') {
        payload.filters.push(['roles', 'array_contains', this.selectedRole])
      }
      getUsersFunction(payload)
          .then((result) => {
            console.log("result: ", result.data);
            result.data["users"].forEach((user) => {
              this.usersData.push({
                user: user,
                name: this.getFullName(user.name),
                role: user.roles[0]
              });
            });
            this.isLoading = false
          })
          .catch((error) => {
            console.log("Error getting users: ", error);
            this.showError(error.message)
            this.isLoading = false;
          });
    },
    userDetailsLink: function (userId) {
      return "#/users/" + userId
    }
  },
  computed: {
    userRoles() {
      let allUserRoles = this.userRoleOptions.slice();
      allUserRoles.unshift({
        id: "all",
        translationKey: "enums.user-role.all"
      })
      return allUserRoles
    }
  },
  mounted() {
    if (!this.currentUserAccess("Users", this.UserActions.VIEW))
      this.$router.back()
    this.readUsersData()
  }
};
</script>

<style scoped>
.users-table {
  margin-top: 16px;
}
</style>
